import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import TrasladosLocalesManager from './impuestos-locales/TrasladosLocalesManager';
import ImpuestosLocalesBaseForm from './impuestos-locales/ImpuestosLocalesBaseForm';
import RetencionesLocalesManager from './impuestos-locales/RetencionesLocalesManager';

const ComplementoImpuestosLocales = (props) => {
  let initialState = props.data || { version: '1.0' };

  const [state, setState] = useState({
    data: { ...initialState },
    isValid: false,
  });

  const { data, isValid } = state;

  const handleOnChange = (event) => {
    const newState = {
      ...state,
      data: {
        ...state.data,
        ...event.data
      },
      isValid: event.isValid
    };

    setState(newState);
  }

  const handleOnManagerChange = (data) => {
    const newState = {
      ...state,
      data: {
        ...state.data,
        ...data
      },
    };

    setState(newState);
  }

  const handleOnAdd = () => {
    const complemento = {
      ImpuestosLocales: data
    };

    props.onChange(complemento);

    clearState();
  }

  const clearState = () => {
    setState({
      ...state,
      data: {
        version: '1.0'
      }
    });
  }

  const handleOnCancel = () => {
    props.onCancel('ImpuestosLocales');

    clearState();
  }

  return (
    <>
      <div className="pb-4 text-right">
        <strong className="text-black text-upper">Complemento Impuestos Locales</strong>
      </div>

      <div className="pb-4">
        <div className="section pt-2">

          <Form autoComplete="off">

            <ImpuestosLocalesBaseForm data={ data } onChange={ handleOnChange } />

            { data?.TotaldeRetenciones > 0 && (
              <RetencionesLocalesManager data={ data } onChange={ handleOnManagerChange } />
            )}

            { data?.TotaldeTraslados > 0 && (
              <TrasladosLocalesManager data={ data } onChange={ handleOnManagerChange } />
            )}

            <div className="py-2"></div>

            <Row className="pb-3 text-right">
              <Col>
                <Button variant="secondary"
                  className="mr-3"
                  onClick={ handleOnCancel }
                >
                  Cancelar
                </Button>

                <Button variant="secondary"
                  disabled={ !isValid}
                  onClick={ handleOnAdd }
                >
                  Agregar complemento
                </Button>
              </Col>
            </Row>

          </Form>
        </div>
      </div>
    </>
  );
}

export default ComplementoImpuestosLocales;